import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useEditarConfigDeEnvelopeContext } from "../..";
import IconOrSpinner from "../../../../../../Components/Utils/IconOrSpinner";
import { DeletarConfigEnvelopeDestinatarioController } from "../../../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";

interface IDestinatarioASerInseridoNaConfiguracaoProps {
    descricao: string;
    vincular(): Promise<void>;
    idVinculado?: number;
}

export default function DestinatarioASerInseridoNaConfiguracao(
    props: IDestinatarioASerInseridoNaConfiguracaoProps
) {
    const { execute: vincularEmConfiguracao, loading: vinculando } =
        useAsyncCallback(props.vincular);

    const { execute: desvincularEmConfiguracao, loading: desvinculando } =
        useAsyncCallback(DeletarConfigEnvelopeDestinatarioController);

    const { update: updateList } =
        useEditarConfigDeEnvelopeContext().destinatariosConfigEnvelope;

    function handleVincularOuDesvincularButtonClick() {
        let promise: Promise<void>;
        if (props.idVinculado) {
            promise = desvincularEmConfiguracao(props.idVinculado);
        } else {
            promise = vincularEmConfiguracao();
        }
        promise.then(updateList);
    }

    const loading = vinculando || desvinculando;

    return (
        <div className="d-flex justify-content-between p-2">
            <div className="d-flex align-items-center g-2">
                <h4 className="m-0">{props.descricao}</h4>
            </div>
            <button
                className={`btn btn-outline-${
                    props.idVinculado ? "danger" : "success"
                }`}
                onClick={handleVincularOuDesvincularButtonClick}
                disabled={loading}
            >
                <IconOrSpinner
                    icon={props.idVinculado ? faArrowDown : faArrowUp}
                    loading={loading}
                    loadingSize="sm"
                />
            </button>
        </div>
    );
}
